export const isAuthSelector = (state) => state.user.isAuth;
export const userSelector = (state) => state.user;
export const rateSelector = (state) => state.rate;
